export default __webpack_public_path__ + "static/logo_ELIB-6e8f5d7c18dbfa983fa60aa59bf13f74.png";